document.addEventListener('DOMContentLoaded', function () {

    const drawers = document.querySelectorAll('.option-drawer-wrapper');

    if (drawers.length === 0) return;

    function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
    }

    function openDrawer(targetDrawer) {
        const sidebar = targetDrawer.querySelector('.option-drawer');

        targetDrawer.classList.add('active');

        if (sidebar) {
            sidebar.style.transition = '';
            sidebar.style.transform = 'translateX(0)';
        }

        const scrollBarWidth = getScrollbarWidth();
        if (scrollBarWidth > 0) {
            document.body.style.paddingRight = scrollBarWidth + 'px';
        }

        document.body.classList.add('no-scrollY');
    }

    function closeDrawer(targetDrawer) {
        const sidebar = targetDrawer.querySelector('.option-drawer');

        if (sidebar) {
            sidebar.style.transform = 'translateX(100%)';

            const onTransitionEnd = function handler(e) {
                if (e.propertyName === 'transform') {
                    targetDrawer.classList.remove('active');
                    document.body.classList.remove('no-scrollY');
                    document.body.style.paddingRight = '';
                    sidebar.removeEventListener('transitionend', onTransitionEnd);
                }
            };

            sidebar.addEventListener('transitionend', onTransitionEnd);
        } else {
            targetDrawer.classList.remove('active');
            document.body.classList.remove('no-scrollY');
            document.body.style.paddingRight = '';
        }
    }

    // Open drawer and tab via .pdp-accordion-btn
    document.querySelectorAll('.pdp-accordion-btn').forEach(button => {
        button.addEventListener('click', function () {

            const drawerKey = this.getAttribute('data-drawer');
            const tabKey = this.getAttribute('data-tab');

            if (!drawerKey) return;

            const targetDrawer = document.querySelector(`.option-drawer-wrapper[data-drawer="${drawerKey}"]`);

            if (targetDrawer) {
                openDrawer(targetDrawer);

                // If tabKey exists, activate corresponding tab inside the drawer
                if (tabKey) {
                    const tabButtons = targetDrawer.querySelectorAll('.product-tab-btn');
                    const tabContents = targetDrawer.querySelectorAll('.product-tab-content');

                    tabButtons.forEach(btn => btn.classList.remove('active'));
                    tabContents.forEach(content => content.classList.remove('active'));

                    const targetButton = targetDrawer.querySelector(`.product-tab-btn[data-tab="${tabKey}"]`);
                    const targetContent = targetDrawer.querySelector(`.product-tab-content[data-content="${tabKey}"]`);

                    if (targetButton && targetContent) {
                        targetButton.classList.add('active');
                        targetContent.classList.add('active');
                    }
                }
            }
        });
    });

    // Drawer close logic
    drawers.forEach(drawer => {
        const closeBtn = drawer.querySelector('.option-drawer__closer');

        if (closeBtn) {
            closeBtn.addEventListener('click', () => closeDrawer(drawer));
        }

        drawer.addEventListener('click', function (e) {
            if (e.target === drawer) {
                closeDrawer(drawer);
            }
        });
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;

        const activeDrawer = document.querySelector('.option-drawer-wrapper.active');
        if (activeDrawer) {
            closeDrawer(activeDrawer);
        }
    });

});
